import { createFileRoute, redirect } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';

import { StudentPaymentHistoryPage } from '~features/students/ui/student-payment/student-payment-history-page-new';
import {
  BILLING_ADMIN_MIN_ROLE,
  getBillingAdminRedirect,
} from '~features/students/ui/student-payment/billing-admin-redirect.helpers';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const Component = () => {
  const { studentId } = Route.useParams();
  return <StudentPaymentHistoryPage studentId={studentId} />;
};

const PendingComponent = () => {
  return (
    <div className='flex h-48 items-center justify-center'>
      <Loader2 className='size-10 animate-spin' />
    </div>
  );
};

export const Route = createFileRoute('/_auth/_layout/students/$studentId/new-payments')(
  {
    pendingComponent: PendingComponent,
    beforeLoad: async ({ params }) => {
      // ENR-3529: student Payments is Admin+ only (Staff redirected).
      const hasAccess = await checkMinRoleValue(BILLING_ADMIN_MIN_ROLE);
      const redirectTarget = getBillingAdminRedirect({
        hasAdminAccess: hasAccess,
        studentId: params.studentId,
      });
      if (redirectTarget?.redirectTo === '/students/$studentId/details') {
        return redirect({
          to: redirectTarget.redirectTo,
          params: {
            studentId: redirectTarget.studentId,
          },
        });
      }
    },
    component: Component,
    
  },
);
